import { render, staticRenderFns } from "./BarDossierByEdpPrescripteurChart.vue?vue&type=template&id=5fb4d3b2&"
import script from "./BarDossierByEdpPrescripteurChart.vue?vue&type=script&lang=ts&"
export * from "./BarDossierByEdpPrescripteurChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports